import React from 'react';
import { useTranslation } from 'react-i18next';
import './BlockedScreen.css';

interface BlockedScreenProps {
  reason?: string;
  until?: string;
  permanent?: boolean;
}

const BlockedScreen: React.FC<BlockedScreenProps> = ({ reason, until, permanent }) => {
  const { t, i18n } = useTranslation();

  const formatDate = (dateString?: string) => {
    if (!dateString) return '';
    try {
      const date = new Date(dateString);
      const locale = i18n.language === 'ru' ? 'ru-RU' : 'en-US';
      return date.toLocaleString(locale, {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    } catch {
      return dateString;
    }
  };

  const handleSupport = () => {
    window.open('https://t.me/safepermoon', '_blank');
  };

  return (
    <div className="blocked-screen">
      <div className="blocked-container">
        <div className="blocked-icon">🚫</div>

        <h1 className="blocked-title">{t('blocked.title')}</h1>

        {reason && (
          <div className="blocked-reason">
            <strong>{t('blocked.reason')}</strong>
            <p>{reason}</p>
          </div>
        )}

        {permanent ? (
          <div className="blocked-info permanent">
            <p>{t('blocked.permanent')}</p>
          </div>
        ) : until ? (
          <div className="blocked-info temporary">
            <p>{t('blocked.temporary')}</p>
            <p className="blocked-until">
              <strong>{t('blocked.until')}</strong> {formatDate(until)}
            </p>
          </div>
        ) : null}

        <div className="blocked-actions">
          <button className="support-button" onClick={handleSupport}>
            {t('blocked.support')}
          </button>
        </div>

        <div className="blocked-footer">
          <p>{t('blocked.supportHint')}</p>
        </div>
      </div>
    </div>
  );
};

export default BlockedScreen;
